import { render } from "./EditNewMember.vue?vue&type=template&id=a89b5a7c"
import script from "./EditNewMember.vue?vue&type=script&lang=js"
export * from "./EditNewMember.vue?vue&type=script&lang=js"

import "./EditNewMember.vue?vue&type=style&index=0&id=a89b5a7c&lang=css"
import "./EditNewMember.vue?vue&type=style&index=1&id=a89b5a7c&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__